import PeopleMainPage from './PeopleMainPage'

export default PeopleMainPage
